import { render, staticRenderFns } from "./DeviceTargetingConfig.vue?vue&type=template&id=46071846&scoped=true"
import script from "./DeviceTargetingConfig.vue?vue&type=script&lang=js"
export * from "./DeviceTargetingConfig.vue?vue&type=script&lang=js"
import style0 from "./DeviceTargetingConfig.vue?vue&type=style&index=0&id=46071846&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46071846",
  null
  
)

export default component.exports